import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

const Valuation = z.object({
  id: z.string().uuid(),
  input: z.unknown(),
  output_low: z.coerce.number().nullable(),
  output_expected: z.coerce.number().nullable(),
  output_high: z.coerce.number().nullable(),
  confidence: z.coerce.number().nullable(),
  disclaimer_id: z.string(),
  email: z.string().nullable(),
  created_at: z.string(),
});
export type Valuation = z.infer<typeof Valuation>;

const Response = z.object({ items: z.array(Valuation) });

export function useValuations() {
  const { session } = useAuth();
  const token = session?.access_token;
  return useQuery({
    queryKey: ["valuations"],
    enabled: !!token,
    queryFn: async (): Promise<Valuation[]> => {
      const r = await apiFetch("/api/v1/admin/valuations", token!, Response);
      return r.items;
    },
  });
}
